import type { User } from '@/types'

import type {
    CustomerFeedbacks,
    ExecutivesDashboardData,
    KPI,
    RevenueAnalys,
    TechnicianBase,
    TechnicianPerfomance,
} from '../../types/executives'
import { objectToQueryString } from '../../utils/helpers'
import { baseApi } from '../baseApi'
import type { DateRangeQueryParams, ResponseType } from '../types'

import type {
    CustomerFeedbacksQueryParams,
    ExecutivesDashboardQueryParams,
    SearchResponse,
    TechnicianPerformanceQueryParams,
    TechniciansQueryParams,
} from './response.interface'

const authBase = 'api/executives'

export const executivesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getExecutivesUsers: builder.query<
            ResponseType<User[]>,
            ExecutivesDashboardQueryParams
        >({
            query: (query) => `${authBase}/users`,
        }),
        getDashboard: builder.query<
            ResponseType<ExecutivesDashboardData>,
            ExecutivesDashboardQueryParams
        >({
            query: (query) =>
                `${authBase}/dashboard?${objectToQueryString(query)}}`,
        }),
        getSearch: builder.query<ResponseType<SearchResponse>, string>({
            query: (query) => `${authBase}/search?${query}`,
        }),
        getTechnicianPerfomance: builder.query<
            ResponseType<TechnicianPerfomance[]>,
            TechnicianPerformanceQueryParams
        >({
            query: (query) => `${authBase}/technician-perfomance?${query}`,
        }),
        getTechnicians: builder.query<ResponseType<TechnicianBase[]>, string>({
            query: (qwery) => `${authBase}/technicians?${qwery}`,
        }),
        getCustomerFeedbacks: builder.query<
            ResponseType<CustomerFeedbacks[]>,
            CustomerFeedbacksQueryParams
        >({
            query: (query) =>
                `${authBase}/customer-feedbacks?${objectToQueryString(query)}`,
        }),
        getRevenueAnalysis: builder.query<
            ResponseType<RevenueAnalys>,
            DateRangeQueryParams
        >({
            query: (query) => `${authBase}/revenue-analysis?${query}`,
        }),
        getKPI: builder.query<ResponseType<KPI>, DateRangeQueryParams>({
            query: (query) => `${authBase}/kpi?${objectToQueryString(query)}`,
        }),
    }),
})

export const {
    useGetDashboardQuery,
    useGetSearchQuery,
    useGetCustomerFeedbacksQuery,
    useGetKPIQuery,
    useGetTechnicianPerfomanceQuery,
    useGetRevenueAnalysisQuery,
    useGetTechniciansQuery,
    useLazyGetTechniciansQuery,
    useLazyGetExecutivesUsersQuery,
} = executivesApi
